import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import { Button } from "components";


class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    //console.log(this.props.postimageUrl);
    this.state = {
      file: null,
      img_files: [],
      imagePreviewUrl: this.props.avatar ? "" : ""
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  componentWillMount() {
    if (this.props.imageUrl) {
      this.setState({
        imagePreviewUrl: this.props.imageUrl
      });
    }
    if (this.props.postimageUrl) {
      this.setState({
        imagePreviewUrl: this.props.postimageUrl
      });
    }
  }
  handleImageChange(e) {
    e.preventDefault();
    for (var x = 0; x < e.target.files.length; x++) {
      let reader = new FileReader();
      let file = e.target.files[x];
      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        });
        this.state.img_files.push(this.state.file);
        console.log(this.state.img_files);
        this.props.getFile(this.state.img_files);
      };
      reader.readAsDataURL(file);
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar ? "" : ""
    });
    this.refs.fileInput.value = null;
  }
  render() {
    return (
      <div className="fileinput text-center">
        <input
          type="file"
          onChange={this.handleImageChange}
          ref="fileInput"
          multiple
        />
        <div className={"thumbnail" + (this.props.avatar ? " img-circle" : "")}>
          <img src={this.state.imagePreviewUrl} alt="..." />
        </div>
        <div>
          {this.state.file === null ? (
            <Button round onClick={() => this.handleClick()}>
              {this.props.avatar ? "Add Photo" : "Select image"}
            </Button>
          ) : (
            <span>
              <Button round onClick={() => this.handleClick()}>
                Change
              </Button>
              {this.props.avatar ? <br /> : null}
              <Button color="danger" round onClick={() => this.handleRemove()}>
                <i className="fa fa-times" /> Remove
              </Button>
            </span>
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool
};

export default ImageUpload;
